export default __webpack_public_path__ + "static/media/inn-single-product.be4e9201.png";